var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: {
        transform:
          "translate3d(" +
          _vm.x +
          "px, " +
          _vm.y +
          "px, 0) scale(" +
          _vm.scale +
          ")"
      },
      attrs: { "data-namespace": "movable-item" }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }